import path from 'path';
const getDirname = path.dirname;
export default getDirname;